import {
  CapacityGranularity,
  capacityGranularity,
} from "./capacityGranularity";
import { CapacitySort } from "./capacitySort";
import { Filter } from "./filter";
import { Id } from "./id";

type RetrieveWorkloadProjectsRequest = {
  resourceId: Id;
  from: string;
  to: string;
  granularity: CapacityGranularity;
  page: number;
  size: number;
  filter?: Filter;
  sort?: CapacitySort;
};

const retrieveWorkloadProjectsRequest: RetrieveWorkloadProjectsRequest = {
  resourceId: "",
  from: "",
  to: "",
  granularity: capacityGranularity,
  page: 0,
  size: 20,
};

export type { RetrieveWorkloadProjectsRequest };

export { retrieveWorkloadProjectsRequest };
